import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { isDefined } from '@fi-shared/utils/is-defined';
import { isFunction } from '@fi-shared/utils/is-function';
import { ItemsListHeader } from '@fi-app/components/items-list/items-list-header';
import { Subject } from 'rxjs';

@Component({
    selector: 'fi-items-list-row-item-display-value',
    templateUrl: './display-value.component.html',
    styleUrls: ['./display-value.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-items-list-row-item-display-value' },
    standalone: false,
})
export class ItemsListRowItemDisplayValueComponent implements OnInit, OnDestroy {
    @Input() data: any;
    @Input() head: ItemsListHeader;
    @Input() parentData: any;

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit() {
        this.head.Properties.updateContent$.takeUntil(this.ngOnDestroy$).subscribe(() => {
            this.cdr.markForCheck();
        });
    }

    GetDisplayValue() {
        return ItemsListRowItemDisplayValueComponent.GetDisplayValue(this.data, this.head, this.parentData);
    }

    isShowSecondaryValue() {
        return this.head.Properties.ExtraProperties && this.head.Properties.ExtraProperties.secondaryValue;
    }

    getSecondaryValue() {
        return this.head.Properties.ExtraProperties.secondaryValue(this.data);
    }

    getMainValueClass() {
        return this.head.Properties.ExtraProperties && this.head.Properties.ExtraProperties.getMainValueClass
            ? this.head.Properties.ExtraProperties.getMainValueClass(this.data)
            : '';
    }

    getSecondaryValueClass() {
        return isDefined(this.head.Properties.ExtraProperties.secondaryValueClass)
            ? this.head.Properties.ExtraProperties.secondaryValueClass
            : 'show-mobile';
    }

    getBadge() {
        return this.head.Properties.ExtraProperties && this.head.Properties.ExtraProperties.getBadge
            ? this.head.Properties.ExtraProperties.getBadge(this.data)
            : '';
    }

    static GetDisplayValue(data, head: ItemsListHeader, parentData?) {
        const dataToDisplay =
            head.Properties.ExtraProperties && head.Properties.ExtraProperties.useParentDataForDisplay && parentData
                ? parentData
                : data;

        if (head.DisplayPropertyName) {
            if (isFunction(head.DisplayPropertyName))
                return head.DisplayPropertyName(data, head.PropertyName, parentData);
            return dataToDisplay[head.DisplayPropertyName];
        }
        return dataToDisplay[head.PropertyName];
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
